import { IconButton, Stack } from "~/common/mui";
import { PopperTooltip } from "~/common/components/Tooltip";
import { useTranslation } from "react-i18next";
import { IMG_DMC_TEASER } from "~/utils/url/staticResources";
import { C_ON_SURFACE_VARIANT } from "~/common/components/icon/Colors";
import QrCodeScannerOutlinedIcon from "@mui/icons-material/QrCodeScannerOutlined";

import classes from "./DesktopScanDMCTeaser.module.less";
import classNames from "classnames";
import { resetQualtrics } from "~/common/utils/misc";

interface Props {
  className?: string;
}

export const DesktopScanDMCTeaser = (props: Props) => {
  const { t } = useTranslation();
  return (
    <PopperTooltip
      className={classes.root}
      placement={"bottom"}
      innerClassName={"p-0"}
      tooltipContent={
        <Stack gap={3} className={classNames(props.className, classes.tooltip)}>
          <h3 className={classes.title}>{t("qualtrics.scandmc.title")}</h3>
          <p>{t("qualtrics.scandmc.paragraph.1")}</p>
          <img src={IMG_DMC_TEASER} className={classes.image} />
          <Stack gap={2}>
            {/*<p>{t("qualtrics.scandmc.paragraph.2")}</p>*/}
            <div id={"qualtricsScanning"} />
          </Stack>
        </Stack>
      }
      onTooltipOpened={resetQualtrics}
    >
      <IconButton sx={{ color: C_ON_SURFACE_VARIANT }}>
        <QrCodeScannerOutlinedIcon />
      </IconButton>
    </PopperTooltip>
  );
};
